"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreakScore = void 0;
const Score_1 = require("./Score");
const pixi_js_1 = require("pixi.js");
const AssetManager_1 = __importDefault(require("../managers/AssetManager"));
const Global_1 = require("../Global");
class StreakScore extends Score_1.Score {
    constructor(app) {
        super(app, pixi_js_1.Sprite.from(AssetManager_1.default.fire));
    }
    update(by) {
        const _super = Object.create(null, {
            update: { get: () => super.update }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.update.call(this, by, this.text, 'stats.streak');
        });
    }
    layout() {
        this.icon.scale.set((0, Global_1.px)(this.overSmallSize ? 0.14 : 0.122));
        super.layout();
    }
}
exports.StreakScore = StreakScore;
